import {
	formatDateLabel,
	parseDate,
	formatMessageTime,
} from "../../utils/dateUtils";

export default function ChatMessages({
	messages,
	matchIndexes,
	currentMatch,
	chatSearch,
	highlightText,
	bottomRef,
}) {
	const isSearching = chatSearch.trim() !== "";

	return (
		<div className="theme-scrollbar min-h-0 flex-1 overflow-y-auto p-4 space-y-2 bg-[#efeae2]">
			{messages.map((msg, index) => {
				const prevMsg = messages[index - 1];

				const showDateSeparator =
					index === 0 ||
					parseDate(prevMsg.time).toDateString() !==
						parseDate(msg.time).toDateString();

				const isMatch = isSearching && matchIndexes.includes(index);
				const isActive = isSearching && matchIndexes[currentMatch] === index;

				return (
					<div key={msg.id}>
						{/* DATE */}
						{showDateSeparator && (
							<div className="flex justify-center my-3">
								<span className="text-xs bg-gray-200 text-gray-600 px-3 py-1 rounded-full shadow-sm">
									{formatDateLabel(msg.time)}
								</span>
							</div>
						)}

						{/* MESSAGE */}
						<div
							id={`msg-${index}`}
							className={`flex ${
								msg.from === "user" ? "justify-end" : "justify-start"
							}`}
						>
							<div
								className={`relative px-3 py-2 text-sm shadow-sm min-w-[120px] max-w-[70%] pb-5
								${
									msg.from === "user"
										? "bg-[#0b5cff] text-white rounded-tl-2xl rounded-bl-2xl rounded-tr-2xl rounded-br-sm"
										: "bg-white border border-gray-200 rounded-tr-2xl rounded-br-2xl rounded-tl-2xl rounded-bl-sm"
								}
								${isActive ? "ring-2 ring-yellow-400" : ""}
							`}
							>
								{/* SENT BY */}
								{msg.from === "user" && msg.sentBy && (
									<div className="text-[11px] font-medium opacity-80 mb-1">
										{msg.sentBy}
									</div>
								)}

								{/* MESSAGE TEXT */}
								<div className="break-words pr-12">
									{isMatch ? highlightText(msg.text, chatSearch) : msg.text}
								</div>

								{/* ✅ TIME + STATUS TICKS */}
								<div className="absolute bottom-1 right-2 flex items-center gap-1 text-[11px]">
									<span className="text-white/70">
										{formatMessageTime(msg.time)}
									</span>

									{msg.from === "user" && (
										<span className="flex items-center gap-[1px] ml-1">
											{/* sending */}
											{msg.status === "sending" && (
												<span className="w-2 h-2 border-2 border-white/50 border-t-transparent rounded-full animate-spin"></span>
											)}

											{/* sent */}
											{msg.status === "sent" && (
												<span className="text-white/60 text-[12px] leading-none">
													✓
												</span>
											)}

											{/* delivered */}
											{msg.status === "delivered" && (
												<span className="text-white/60 text-[12px] tracking-[-2px]">
													✓✓
												</span>
											)}

											{/* read */}
											{msg.status === "read" && (
												<span className="text-cyan-300 font-semibold text-[13px] tracking-[-2px] drop-shadow-[0_0_2px_rgba(255,255,255,0.6)]">
													✓✓
												</span>
											)}
										</span>
									)}
								</div>
							</div>
						</div>
					</div>
				);
			})}

			<div ref={bottomRef}></div>
		</div>
	);
}
